var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_card-coin",
    "data-name": "vuesax/bulk/card-coin",
    transform: "translate(-108 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-coin",
    transform: "translate(108 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H22V22H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.839,1.725V2.2H0V1.725C0,.345.345,0,1.74,0H6.1C7.494,0,7.839.345,7.839,1.725Z",
    transform: "translate(3.178 12.176)",
    fill: "#3e5bfd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0V2.736C0,4.116.345,4.46,1.74,4.46H6.1c1.4,0,1.74-.345,1.74-1.725V0Z",
    transform: "translate(3.178 14.379)",
    fill: "#3e5bfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.59 2.573)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_Stroke_",
    "data-name": "Vector (Stroke)",
    d: "M6.075,0a.588.588,0,0,1,.588.588A6.071,6.071,0,0,1,.588,6.663a.588.588,0,0,1-.5-.89L.907,4.4a.588.588,0,1,1,1.008.6L1.7,5.36A4.9,4.9,0,0,0,5.487.588.588.588,0,0,1,6.075,0Z",
    transform: "translate(10.191 10.191)",
    fill: "#3e5bfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_Stroke_2",
    "data-name": "Vector (Stroke)",
    d: "M4.961,1.3A4.9,4.9,0,0,0,1.176,6.075.588.588,0,1,1,0,6.075,6.071,6.071,0,0,1,6.075,0a.588.588,0,0,1,.5.89L5.756,2.262a.588.588,0,1,1-1.008-.6Z",
    transform: "translate(0 0)",
    fill: "#3e5bfd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M7.055,0H0A3.533,3.533,0,0,0,3.528,3.528,3.528,3.528,0,0,0,7.055,0Z",
    transform: "translate(12.585 6.689)",
    fill: "#3e5bfd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M7.055,3.528A3.528,3.528,0,1,0,0,3.528Z",
    transform: "translate(12.585 3.161)",
    fill: "#3e5bfd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/recurring.5e57a760547fc23331b34ec3a36d567b.svg";
export { ForwardRef as ReactComponent };